// extracted by mini-css-extract-plugin
export default {"variants":"CheckVariants_variants__VexKs","variant":"CheckVariants_variant__EhBFE","img":"CheckVariants_img__gpZdg","checkbox":"CheckVariants_checkbox__AYVwo"};